import React, { useEffect } from 'react';
import { Switch } from 'react-router';
import { useHistory, useLocation } from 'react-router-dom';

import { ProtectedRoute } from '../../../../utils/ProtectedRoute';
import { WizardStepsRouteConfig } from '../../utils/types';

export const WizardStepSwitcher: React.FC<{
  steps: WizardStepsRouteConfig;
  onBackNavigation?: () => void;
}> = ({ steps, onBackNavigation }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        onBackNavigation?.();
      }
    };
  }, [history, history.action, location.pathname, onBackNavigation]);

  return (
    <Switch>
      {Object.entries(steps).map(([_, { routeConfig, element }]) => (
        <ProtectedRoute
          key={routeConfig.path}
          routeConfig={routeConfig}
          path={routeConfig.path}
          exact
        >
          {element}
        </ProtectedRoute>
      ))}
    </Switch>
  );
};
